// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_od-0";
export var discountCodeInput = "_od-1";